import React from 'react';
import PropTypes from 'prop-types';

import { Link, Title, Spacer, Message } from 'src/core/components';

import messages from './messages';
import './EmptyOverviewStyle.scss';

const EmptyOverview = ({ staticMenuItems = [] }) => (
  <>
    <Title
      className="mcp-static-links-title"
      size="3"
      message={messages.toolsForProject}
    />
    <Spacer bottom={16} />
    <div className="mcp-static-links">
      <Link href={staticMenuItems[0].productLink} target="_blank">
        {staticMenuItems[0].name}
      </Link>
      <Link href={staticMenuItems[1].productLink} target="_blank">
        {staticMenuItems[1].name}
      </Link>
    </div>
    <Spacer bottom={56} />
    <Title
      className="mcp-static-links-title"
      size="3"
      message={messages.customizedProducts}
    />
    <Spacer bottom={16} />
    <div className="mcp-static-links">
      <Link href={staticMenuItems[0].productLink} target="_blank">
        <Message message={messages.seeYourProducts} />
      </Link>
      <Link href={staticMenuItems[3]?.productLink} target="_blank">
        <Message message={messages.customProductsLines} />
      </Link>
    </div>
  </>
);

EmptyOverview.propTypes = {
  staticMenuItems: PropTypes.array
};

export default EmptyOverview;
